<template>
  <div class="form-creator">
    <b-row>
      <b-col md="6">
        <p>
          <strong>Nazwa:</strong> <b-form-input v-model="form.formName" />
        </p>
      </b-col>
      <b-col md="6">
        <p>
          <strong>Projekt:</strong>
          <b-form-select id="project" :plain="true" :options="projectsOptions" v-model="form.projectId" :disabled="this.initForm !== undefined"/>
        </p>
      </b-col>
      <b-col md="12">
        <p>
          <strong>URL strony podziękowań po wypełnieniu formularza:</strong>
          <b-form-input v-model="form.thankYouPageUrl" />
        </p>
      </b-col>
      <b-col md="12">
        <p>
          <strong>Napis na przycisku wysyłki formularza:</strong>
          <b-form-input v-model="form.submitLabel" />
        </p>
      </b-col>
      <b-col md="12">
        <p>
          <strong>HTML widoczny po wysłaniu formularza:</strong>
          <b-form-textarea v-model="form.thankYouHtml" />
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="field-box" v-bind:key="index" v-bind:item="input" v-for="(input, index) in form.inputs">
          <fieldset>
            <legend>{{ input.name }}</legend>
            <b-input-group>
              <b-input-group-prepend>
                <c-required-label label="Nazwa"></c-required-label>
              </b-input-group-prepend>
              <b-form-input v-model="input.name"/>
              <b-input-group-prepend>
                <c-required-label label="Typ"></c-required-label>
              </b-input-group-prepend>
              <b-form-select v-model="input.type" :options="fieldTypeOptions"/>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <b-input-group-text>Nagłówek:</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input v-model="input.options.label"/>
            </b-input-group>
            <b-input-group v-if="hasPlaceholder(input.type)">
              <b-input-group-prepend>
                <b-input-group-text>Placeholder:</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input v-model="input.options.placeholder"/>
            </b-input-group>
            <b-input-group v-if="input.type === 'select'">
              <b-input-group-prepend>
                <b-input-group-text>Domyślnie wyświetl:</b-input-group-text>
              </b-input-group-prepend>
              <b-form-input v-model="input.options.initialOption"/>
            </b-input-group>
            <fieldset class="validation-rules">
              <legend>Reguły walidacji</legend>
              <div v-if="input.rules.length === 0"><b>--- Brak reguł walidacyjnych ---</b></div>
              <div v-else :key="'R'+i" v-for="(rule, i) in input.rules">
                <div class="validation-rules-box">
                  <b-button variant="danger" size="sm" class="float-right" @click="removeRule(input, i)"><i class="fa fa-close"></i></b-button>
                  <span><strong>Reguła: </strong>{{ ruleText(rule.rule) }}<span v-if="rule.rule === 'custom'"> - {{ rule.custom }}</span></span><br/>
                  <span><strong>Komunikat błędu: </strong>{{ rule.errorMessage }}</span>
                </div>
              </div>
              <div>
                <br/>
                Wprowadź regułę:
                <c-rule-creator :fieldType="input.type" @rule-added="addRule(input, $event)"/>
              </div>
            </fieldset>
            <fieldset v-if="input.type === 'select'" class="validation-rules">
              <legend>Opcje wyboru</legend>
              <div v-if="!input.options.options || input.options.options.length === 0"><b>--- Brak opcji ---</b></div>
              <div v-else :key="'O'+i" v-for="(option, i) in input.options.options">
                <div class="validation-rules-box">
                  <b-button variant="danger" size="sm" class="float-right" @click="removeOption(input, i)"><i class="fa fa-close"></i></b-button>
                  <b-button v-if="i < input.options.options.length - 1" class="float-right move-arrow" title="przesuń w dół" variant="none" @click="moveDown(input.options.options, i)"><i class="fa fa-arrow-down"></i></b-button>
                  <b-button class="float-right move-arrow" v-if="i > 0" title="przesuń w górę" variant="none" @click="moveUp(input.options.options, i)"><i class="fa fa-arrow-up"></i></b-button>
                  <span><strong></strong>{{ option }}</span>
                </div>
              </div>
              <div>
                <br/>
                Dodaj opcję:
                <c-options-creator @option-added="addOption(input, $event)"/>
              </div>
            </fieldset>
            <div style="margin-top: 0.6em">
              <b-button variant="danger" @click="removeInput(index)"><i class="fa fa-close"></i> Usuń</b-button>
              <div class="float-right">
                <b-button class="move-arrow" v-if="index > 0" title="przesuń w górę" variant="none" @click="moveUp(form.inputs, index)"><i class="fa fa-arrow-up"></i></b-button>
                <b-button v-if="index < form.inputs.length - 1" class="move-arrow" title="przesuń w dół" variant="none" @click="moveDown(form.inputs, index)"><i class="fa fa-arrow-down"></i></b-button>
              </div>
            </div>
          </fieldset>
          <br/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <fieldset>
          <legend>Nowe pole</legend>
          <b-input-group>
              <b-form-input v-model="newField.name" placeholder="nazwa pola np. telefon" @keyup.enter="addField(newField)"></b-form-input>
              <b-form-select v-model="newField.type" :options="fieldTypeOptions"></b-form-select>
              <b-button size="sm" variant="success" @click="addField(newField)">Dodaj</b-button>
          </b-input-group>
        </fieldset>
      </b-col>
    </b-row>
    <hr>
    <b-button variant="primary" class="float-right" @click="saveForm()">{{ this.initForm ? 'Zapisz' : 'Utwórz' }}</b-button>
  </div>
</template>
<script>

import formHelper from './formHelper'
import CRuleCreator from './RuleCreator'
import CRequiredLabel from './RequiredLabel'
import COptionsCreator from './OptionCreator'

export default {
  props: ['projects', 'initForm'],
  components: {
    COptionsCreator,
    CRequiredLabel,
    CRuleCreator
  },
  data () {
    return {
      form: this.initializeForm(),
      fieldTypeOptions: [
        { text: formHelper.inputTypeText('text'), value: 'text' },
        { text: formHelper.inputTypeText('textarea'), value: 'textarea' },
        { text: formHelper.inputTypeText('select'), value: 'select' },
        { text: formHelper.inputTypeText('checkbox'), value: 'checkbox' },
        { text: formHelper.inputTypeText('date'), value: 'date' }
      ],
      newField: this.emptyField()
    }
  },
  created () {
    this.getProjectOptions()
  },
  name: 'c-form-creator',
  methods: {
    initializeForm () {
      if (this.initForm) {
        return JSON.parse(JSON.stringify(this.initForm))
      }
      return {
        formName: '',
        projectId: -1,
        inputs: [],
        thankYouPageUrl: null,
        thankYouHtml: '<h2>Formularz został wypełniony.</h2>\n' + '<h4>Wkrótce się z Tobą skontaktujemy.</h4>',
        submitLabel: 'Wyślij'
      }
    },
    getProjectOptions () {
      this.projectsOptions = []
      const self = this
      this.projects.forEach(function (project) {
        self.projectsOptions.push({ text: project.name, value: project.id })
      })
    },
    emptyField () {
      return {
        name: null,
        type: 'text',
        rules: [],
        options: {
          label: null,
          placeholder: null,
          initialOption: null
        }
      }
    },
    addField (field) {
      if (field.name === null || field.type === null) {
        return
      }
      this.form.inputs.push({
        name: field.name,
        type: field.type,
        rules: field.rules,
        options: field.options
      })
      this.newField = this.emptyField()
    },
    addRule (input, rule) {
      input.rules.push(rule)
    },
    removeRule (input, ruleIndex) {
      input.rules.splice(ruleIndex, 1)
    },
    ruleText (rule) {
      return formHelper.ruleText(rule)
    },
    saveForm () {
      this.$emit('saved', this.form)
    },
    removeInput (key) {
      this.form.inputs.splice(key, 1)
    },
    moveUp (array, i) {
      const tmp = array[i]
      array.splice(i, 1, array[i - 1])
      array.splice(i - 1, 1, tmp)
    },
    moveDown (array, i) {
      const tmp = array[i]
      array.splice(i, 1, array[i + 1])
      array.splice(i + 1, 1, tmp)
    },
    hasPlaceholder (type) {
      if (type === 'select' || type === 'checkbox') {
        return false
      }
      return true
    },
    addOption (input, option) {
      if (!Object.hasOwn(input.options, 'options')) {
        this.$set(input.options, 'options', [])
      }

      if (input.options.options.indexOf(option) === -1) {
        input.options.options.push(option)
      }
    },
    removeOption (input, index) {
      input.options.options.splice(index, 1)
    }
  }
}
</script>
